export default [
  {
    name: "Hintergrund, Farbe, Bilder, Skalierung",
    properties: [
      {
        name: "Color",
        value: "background-color",
        type: "color",
        shorthand: "background",
      },
      {
        name: "Image",
        value: "background-image",
        type: "text",
        shorthand: "background",
      },
      {
        name: "Blend Mode",
        value: "background-blend-mode",
        type: "text",
        autocomplete: [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity",
        ],
        shorthand: "background",
      },
      {
        name: "Size",
        value: "background-size",
        type: "length",
        autocomplete: ["cover", "containt", "auto", "inherit", "initial"],
        shorthand: "background",
      },
      {
        name: "Position",
        value: "background-position",
        type: "text",
        autocomplete: ["top", "right", "bottom", "left", "center", "inherit", "initial"],
        shorthand: "background",
      },
      {
        name: "Repeat",
        value: "background-repeat",
        type: "text",
        autocomplete: ["repeat", "repeat-x", "repeat-y", "no-repeat", "space", "round", "inherit", "initial"],
        shorthand: "background",
      },
      {
        name: "Origin",
        value: "background-origin",
        type: "text",
        autocomplete: ["border-box", "padding-box", "content-box", "inherit", "initial"],
        shorthand: "background",
      },
      {
        name: "Clip",
        value: "background-clip",
        type: "text",
        autocomplete: ["border-box", "padding-box", "content-box", "inherit", "initial"],
        shorthand: "background",
      },
      {
        name: "Attachement",
        value: "background-attachement",
        type: "text",
        autocomplete: ["scroll", "fixed", "local", "inherit", "initial"],
        shorthand: "background",
      },
      {
        name: "Background",
        value: "background",
        type: "text",
      },
      {
        name: "Opacity",
        value: "opacity",
        type: "number",
      },
      {
        name: "Object Fit",
        value: "object-fit",
        type: "text",
        autocomplete: ["fill", "contain", "cover", "none", "scale-down"],
      },
      {
        name: "Object Position",
        value: "object-position",
        type: "text",
        autocomplete: ["top", "right", "bottom", "left", "center", "inherit", "initial"],
      }
    ],
  },
  {
    name: "Effekte und Filter",
    properties: [
      {
        name: "Box Shadow",
        value: "box-shadow",
        type: "text",
      },
      {
        name: "Filter",
        value: "filter",
        type: "function",
        autocomplete: [
          "blur",
          "brightness",
          "contrast",
          "drop-shadow",
          "grayscale",
          "hue-rotate",
          "invert",
          "opacity",
          "saturate",
          "sepia",
          "url",
        ],
      },
      {
        name: "Backdrop Filter",
        value: "backdrop-filter",
        type: "function",
        autocomplete: [
          "blur",
          "brightness",
          "contrast",
          "drop-shadow",
          "grayscale",
          "hue-rotate",
          "invert",
          "opacity",
          "saturate",
          "sepia",
          "url",
        ],
      },
    ],
  },
  {
    name: "Grafiken und Formen",
    properties: [
      {
        name: "Rendering",
        value: "image-rendering",
        type: "text",
        autocomplete: ["auto", "crisp-edges", "pixelated"],
      },
      {
        name: "Blend Mode",
        value: "mix-blend-mode",
        type: "text",
        autocomplete: [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity",
          "initial",
          "inherit",
        ],
      },
      {
        name: "Isolation",
        value: "isolation",
        type: "text",
        autocomplete: ["auto", "isolate", "inherit", "initial"],
      },
      {
        name: "Clip Path",
        value: "clip-path",
        type: "text",
        autocomplete: ["none", "fill-box", "stroke-box", "view-box", "url", "linear-gradient", "inset", "circle", "polygon", "inherit", "initial"],
      },
      {
        name: "Shape Threshold",
        value: "shape-threshold",
        type: "number",
      },
      {
        name: "Shape Margin",
        value: "shape-margin",
        type: "length",
      },
      {
        name: "Shape Outside",
        value: "shape-outside",
        type: "text",
        autocomplete: [
          "none",
          "margin-box",
          "content-box",
          "border-box",
          "padding-box",
          "circle",
          "ellipse",
          "inset",
          "polygon",
          "path",
          "url",
          "linear-gradient",
          "inherit",
          "initial",
        ],
      },
    ],
  },
  {
    name: "Rahmen und Konturen",
    properties: [
      {
        name: "Border",
        value: "border",
        type: "text",
      },
      {
        name: "Top Border",
        value: "border-top",
        type: "text",
      },
      {
        name: "Top Border Width",
        value: "border-top-width",
        type: "text",
        shorthand: "border-top",
      },
      {
        name: "Top Border Style",
        value: "border-top-style",
        type: "text",
        shorthand: "border-top",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
      },
      {
        name: "Top Border Color",
        value: "border-top-color",
        type: "color",
        shorthand: "border-top",
      },
      {
        name: "Top Border Right Radius",
        value: "border-top-right-radius",
        type: "text",
        shorthand: "border-radius",
      },
      {
        name: "Top Border Left Radius",
        value: "border-top-left-radius",
        type: "text",
        shorthand: "border-radius",
      },
      {
        name: "Right Border",
        value: "border-right",
        type: "text",
      },
      {
        name: "Right Border Width",
        value: "border-right-width",
        type: "text",
        shorthand: "border-right",
      },
      {
        name: "Right Border Style",
        value: "border-right-style",
        type: "text",
        shorthand: "border-right",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
      },
      {
        name: "Right Border Color",
        value: "border-right-color",
        type: "color",
        shorthand: "border-right",
      },
      {
        name: "Bottom Border",
        value: "border-bottom",
        type: "text",
      },
      {
        name: "Bottom Border Width",
        value: "border-bottom-width",
        type: "text",
        shorthand: "border-bottom",
      },
      {
        name: "Bottom Border Style",
        value: "border-bottom-style",
        type: "text",
        shorthand: "border-bottom",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
      },
      {
        name: "Bottom Border Color",
        value: "border-bottom-color",
        type: "color",
        shorthand: "border-bottom",
      },
      {
        name: "Bottom Border Right Radius",
        value: "border-bottom-right-radius",
        type: "text",
        shorthand: "border-radius",
      },
      {
        name: "Bottom Border Left Radius",
        value: "border-bottom-left-radius",
        type: "text",
        shorthand: "border-radius",
      },
      {
        name: "Left Border",
        value: "border-left",
        type: "text",
      },
      {
        name: "Left Border Width",
        value: "border-left-width",
        type: "text",
        shorthand: "border-left",
      },
      {
        name: "Left Border Style",
        value: "border-left-style",
        type: "text",
        shorthand: "border-left",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
      },
      {
        name: "Left Border Color",
        value: "border-left-color",
        type: "color",
        shorthand: "border-left",
      },
      {
        name: "Border Color",
        value: "border-color",
        type: "color",
      },
      {
        name: "Border Image",
        value: "border-image",
        type: "text",
      },
      {
        name: "Border Image Outset",
        value: "border-image-outset",
        type: "length",
        shorthand: "border-image",
      },
      {
        name: "Border Image Repeat",
        value: "border-image-repeat",
        type: "text",
        shorthand: "border-image",
        autocomplete: ["stretch", "repeat", "round", "space"],
      },
      {
        name: "Border Image Slice",
        value: "border-image-slice",
        type: "number",
        shorthand: "border-image",
      },
      {
        name: "Border Image Source",
        value: "border-image-source",
        type: "text",
        shorthand: "border-image",
      },
      {
        name: "Border Image Width",
        value: "border-image-width",
        type: "length",
        shorthand: "border-image",
      },
      {
        name: "Border Style",
        value: "border-style",
        type: "text",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
      },
      {
        name: "Border Width",
        value: "border-width",
        type: "length",
        autocomplete: ["thin", "medium", "thick", "inherit", "initial"],
      },
      {
        name: "Border Spacing",
        value: "border-spacing",
        type: "length",
      },
      {
        name: "Border Radius",
        value: "border-radius",
        type: "length",
      },
      {
        name: "Collapse Borders",
        value: "border-collapse",
        type: "text",
        autocomplete: ["collapse", "separate", "inherit", "initial"],
      },
      {
        name: "Outline",
        value: "outline",
        type: "text",
      },
      {
        name: "Outline Color",
        value: "outline-color",
        type: "color",
        shorthand: "outline",
      },
      {
        name: "Outline Style",
        value: "outline-style",
        type: "text",
        autocomplete: ["auto", "none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset"],
        shorthand: "outline",
      },
      {
        name: "Outline Width",
        value: "outline-width",
        type: "text",
        shorthand: "outline",
      },
      {
        name: "Outline Offset",
        value: "outline-offset",
        type: "length",
      },
    ],
  },
  {
    name: "Logical Border Properties",
    properties: [
      {
        name: "Border Block",
        value: "border-block",
        type: "text",
      },
      {
        name: "Start Border Block",
        value: "border-block-start",
        type: "text",
      },
      {
        name: "Start Border Block Width",
        value: "border-block-start-width",
        type: "text",
        shorthand: "border-block-start",
      },
      {
        name: "Start Border Block Style",
        value: "border-block-start-style",
        type: "text",
        shorthand: "border-block-start",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
      },
      {
        name: "Start Border Block Color",
        value: "border-block-start-color",
        type: "color",
        shorthand: "border-block-start",
      },
      {
        name: "End Border Block",
        value: "border-block-end",
        type: "text",
      },
      {
        name: "End Border Block Width",
        value: "border-block-end-width",
        type: "text",
        shorthand: "border-block-end",
      },
      {
        name: "End Border Block Style",
        value: "border-block-end-style",
        type: "text",
        shorthand: "border-block-end",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
      },
      {
        name: "End Border Block Color",
        value: "border-block-end-color",
        type: "color",
        shorthand: "border-block-end",
      },
      {
        name: "Border Inline",
        value: "border-inline",
        type: "text",
      },
      {
        name: "Start Border Inline",
        value: "border-inline-start",
        type: "text",
      },
      {
        name: "Start Border Inline Width",
        value: "border-inline-start-width",
        type: "text",
        shorthand: "border-inline-start",
      },
      {
        name: "Start Border Inline Style",
        value: "border-inline-start-style",
        type: "text",
        shorthand: "border-inline-start",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
      },
      {
        name: "Start Border Inline Color",
        value: "border-inline-start-color",
        type: "color",
        shorthand: "border-inline-start",
      },
      {
        name: "End Border Inline",
        value: "border-inline-end",
        type: "text",
      },
      {
        name: "End Border Inline Width",
        value: "border-inline-end-width",
        type: "text",
        shorthand: "border-inline-end",
      },
      {
        name: "End Border Inline Style",
        value: "border-inline-end-style",
        type: "text",
        shorthand: "border-inline-end",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
      },
      {
        name: "End Border Inline Color",
        value: "border-inline-end-color",
        type: "color",
        shorthand: "border-inline-end",
      },
      {
        name: "Border Block Color",
        value: "border-block-color",
        type: "color",
        shorthand: "border-block",
      },
      {
        name: "Border Inline Color",
        value: "border-inline-color",
        type: "color",
        shorthand: "border-inline",
      },
      {
        name: "Border Block Style",
        value: "border-block-style",
        type: "text",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
        shorthand: "border-block",
      },
      {
        name: "Border Inline Style",
        value: "border-inline-style",
        type: "text",
        autocomplete: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "hidden"],
        shorthand: "border-inline",
      },
      {
        name: "Border Block Width",
        value: "border-block-width",
        type: "length",
        autocomplete: ["thin", "medium", "thick", "inherit", "initial"],
        shorthand: "border-block",
      },
      {
        name: "Border Inline Width",
        value: "border-inline-width",
        type: "length",
        autocomplete: ["thin", "medium", "thick", "inherit", "initial"],
        shorthand: "border-inline",
      },
    ],
  },
];
